var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shop-area-selector__wrap" },
    [
      _c("yxt-select", {
        staticStyle: { width: "100%" },
        attrs: {
          id: "BelongAreaSelect",
          value: _vm.value,
          placeholder: _vm.$t(_vm.place),
          "hidden-option": "",
          "value-key": "id",
          "prop-label": "areaName",
        },
        on: { "visible-change": _vm.switchOptionsPanel },
        scopedSlots: _vm._u([
          {
            key: "tag",
            fn: function (ref) {
              var data = ref.data
              return [_c("span", [_vm._v(_vm._s(data.currentLabel))])]
            },
          },
        ]),
      }),
      _c("transition", { attrs: { name: "yxt-zoom-in-top" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.customOptionsVisible,
                expression: "customOptionsVisible",
              },
            ],
            staticClass: "yxtbiz-shop-custom-options__wrap",
            attrs: { id: "CustomOptions" },
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
                return _vm.noop.apply(null, arguments)
              },
            },
          },
          [
            _c("yxt-input", {
              attrs: {
                placeholder: _vm.$t(
                  "pc_biz_shoptour_input_search_area" /* 请输入区域名称模糊搜索 */
                ),
                searchable: "",
                clearable: "",
              },
              on: { clear: _vm.search, search: _vm.search },
              model: {
                value: _vm.filterText,
                callback: function ($$v) {
                  _vm.filterText = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "filterText",
              },
            }),
            _c("yxt-tree", {
              ref: "tree",
              staticClass: "filter-tree mt10",
              staticStyle: { height: "240px", overflow: "hidden" },
              attrs: {
                "node-key": "id",
                "empty-text": _vm.$t("pc_biz_shoptour_no_data" /* 暂无数据 */),
                "wrap-width": "100%",
                "default-expand-all": false,
                "default-expanded-keys": _vm.expendedRoot,
                virtual: "",
                data: _vm.areaList,
                props: _vm.defaultProps,
                "expand-on-click-node": false,
                "filter-node-method": _vm.filterNode,
                "render-content": _vm.renderContent,
              },
              on: { "node-click": _vm.handleNodeClick },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }